import * as React from "react";

interface InfoIconProps {
  className?: string;
  color?: string;
  onClick?: () => void;
}

export default function InfoIcon({ className, color, onClick }: InfoIconProps) {
  return (
    <div className={className} onClick={onClick}>
      <svg
        width="31"
        height="31"
        viewBox="0 0 31 31"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M24.0907 31L20.6643 31L20.6467 31L17.2203 31L13.7763 31L10.3322 31L6.8882 31L6.8882 27.5474L3.44404 27.5474L3.44404 24.0947L6.03677e-07 24.0947L9.05511e-07 20.6422L1.20638e-06 17.2006L1.20735e-06 17.1896L1.50821e-06 13.748L0.0210987 13.748L0.021099 10.3578L0.0210993 6.90526L3.46514 6.90526L3.46514 3.45257L6.90929 3.45257L6.90929 -2.10608e-06L10.3533 -1.80499e-06L13.7974 -1.5039e-06L17.2414 -1.20282e-06L20.6678 -9.03272e-07L20.6854 -9.01728e-07L24.1118 -6.02184e-07L24.1118 3.45258L27.556 3.45258L27.556 6.90526L31 6.90526L31 10.3578L30.9789 10.3578L30.9789 13.748L30.9789 13.8103L30.9789 17.1896L30.9789 17.2006L30.9789 20.6422L30.9789 24.0947L27.5349 24.0947L27.5349 27.5474L24.0907 27.5474L24.0907 31ZM17.2414 20.7155L17.2414 24.168L13.7974 24.168L13.7974 20.7155L13.7974 17.2629L13.7974 13.8103L17.2414 13.8103L17.2414 17.2629L17.2414 20.7155ZM13.7974 6.90515L17.2414 6.90515L17.2414 10.3577L13.7974 10.3577L13.7974 6.90515ZM17.2414 3.45257L13.7974 3.45257L10.3533 3.45257L6.90929 3.45257L6.90928 6.90526L3.46514 6.90526L3.46514 10.3578L3.46514 13.8104L3.44404 13.8104L3.44404 17.1896L3.44404 17.2006L3.44404 20.6422L3.44404 24.0947L6.8882 24.0947L6.8882 27.5474L10.3322 27.5474L13.7763 27.5474L17.2203 27.5474L20.6467 27.5474L20.6643 27.5474L24.0907 27.5474L24.0907 24.0947L27.5349 24.0947L27.5349 20.6422L27.5349 17.2006L27.5349 17.1896L27.5349 13.8103L27.5349 13.748L27.5349 10.3577L27.556 10.3577L27.556 6.90526L24.1118 6.90526L24.1118 3.45258L20.6854 3.45257L20.6678 3.45257L17.2414 3.45257Z"
          fill="#0099FE"
        />
      </svg>
    </div>
  );
}
